import Evented from "~/lib/evented";

class BusEvents extends Evented {
  listen(type:string, callback: BusEventCallback){
    super.on(type, (event: CustomEvent) => callback( { ...event.detail } ));
  }
  send(type:string, event: BusEvent ){
    return super.dispatchEvent( new CustomEvent(type, {detail: {...event}}));
  }
}

const busEvents = new BusEvents();

export { busEvents };


